import { FC, useState, useEffect } from 'react';
import styles from './index.module.less';
import type { IFeatureVideoBanner } from 'mod/feature/interface';
import { LargeScreenContainer } from '@base/lib/LargeScreenContainer';
import PureVideo from '@base/lib/PureVideo';
import { getWindowWidth } from 'ava-util/dist/dom-window';

type IVideoBannerProps = Globals.BasicHTMLProps & {
    data: IFeatureVideoBanner;
    largeScreen: boolean;
};

type IMediaProps = {
    src: string[];
    poster: string;
};

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

export const VideoBanner: FC<IVideoBannerProps> = props => {
    const {
        data: { config, lists },
        largeScreen = false,
        ...rest
    } = props;

    const [mediaProps, setMediaProps] = useState<IMediaProps>();

    const { height } = config;
    const item = lists[0];

    useEffect(() => {
        if (!item) {
            return;
        }
        const width = getWindowWidth();
        if (width > 1920 && item.largePicUrl) {
            setMediaProps({
                poster: item.largePicUrl,
                src: [
                    item.largeVideoUrl,
                    item.largeVideoBackUpUrl,
                ],
            });
        } else {
            setMediaProps({
                poster: item.picUrl,
                src: [
                    item.videoUrl,
                    item.videoBackUpUrl,
                ],
            });
        }

    }, []);

    return !item ? null : (
        <LargeScreenContainer
            className={styles.container}
            height={height}
            style={{ background: item.bgColor }}
            {...rest}
        >
            {mediaProps ? (
                <PureVideo
                    {...mediaProps}
                    autoPlay={config.videoAutoDisplay === 1}
                    loop={config.videoLoop === 1}
                    controls={config.controls === 1}
                    control={config.control === 1 ? {
                        size: 80,
                        opacity: 1
                    } : false}
                />
            ) : null}
        </LargeScreenContainer>
    )
};
export default VideoBanner;
